import Swiper from 'swiper/bundle';

export function productSlider() {
	const mainSwiperEl = document.querySelector('.productMainSwiper');
	const thumbsSwiperEl = document.querySelector('.productThumbsSwiper');

	if (mainSwiperEl) {
		let thumbsSwiper = null;

		// Initialize thumbs slider if it exists
		if (thumbsSwiperEl) {
			thumbsSwiper = new Swiper('.productThumbsSwiper', {
				spaceBetween: 10,
				slidesPerView: 3,
				watchSlidesProgress: true,
			});
		}

		// Initialize main slider
		const mainSwiper = new Swiper('.productMainSwiper', {
			spaceBetween: 10,
			navigation: {
				nextEl: mainSwiperEl.querySelector('.swiper-button-next'),
				prevEl: mainSwiperEl.querySelector('.swiper-button-prev'),
			},
			thumbs: thumbsSwiper ? {
				swiper: thumbsSwiper,
			} : undefined,
		});
	}
}

